import React, { useState, useCallback, useEffect } from 'react';
import {
  IonRow,
  IonCol,
  IonCardContent,
  IonInput,
  IonCard,
  IonLoading,
  IonSpinner,
  IonIcon,
} from '@ionic/react';
import FormHelperText from '@material-ui/core/FormHelperText';
import Button from '@material-ui/core/Button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import './MyProfile.scss';
import RightSideNav1 from '../../views/CommissionRules/RightSideNav/RightSideNav1';
import CompetitionsMenu from '../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import savebtn from '../../assets/images/common/savebtn.svg';
import API_V2 from '../../api-services/svls-api';

type UpdateUserPersonalDetailsrequest = {
  fullName: string;
  phoneNumber: string;
  emailId: string;
  address: string;
  city: string;
  pinCode: string;
};

type UserPersonalDetails = UpdateUserPersonalDetailsrequest & {
  username: string;
};

const MyProfile: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [progress, setProgress] = useState<boolean>(false);
  const [userDetails, setUserDetails] = useState<UserPersonalDetails>();
  const [successMsg, setSuccessMsg] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');

  const fetchData = useCallback(async () => {
    try {
      setSuccessMsg('');
      setErrorMsg('');
      setLoading(true);

      const userName = sessionStorage.getItem('username');
      const response = await API_V2.get(
        `/account/v2/users/${userName}/profile`,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );

      setUserDetails(response?.data);
    } catch (err) {
      setErrorMsg(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const phoneRegExp = /^\D*(?:\d\D*){10,}$/;
  const pinCodeRegex = /^\+(?:[0-9] ?){6,14}[0-9]$/;
  const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      fullName: userDetails ? userDetails.fullName : null,
      phoneNumber: userDetails ? userDetails.phoneNumber : null,
      emailId: userDetails ? userDetails.emailId : null,
      address: userDetails ? userDetails.address : null,
      city: userDetails ? userDetails.city : null,
      pinCode: userDetails ? userDetails.pinCode : null,
    },
    validationSchema: Yup.object({
      phoneNumber: Yup.string()
        .matches(phoneRegExp, 'Mobile number is not valid')
        .max(10)
        .optional()
        .max(10)
        .nullable(),
      pinCode: Yup.string()
        .matches(pinCodeRegex, 'Pincode is not valid')
        .optional()
        .nullable(),
      emailId: Yup.string()
        .matches(emailRegExp, 'Email is not valid')
        .optional(),
    }),
    onSubmit: (values) => {
      let data: UpdateUserPersonalDetailsrequest = {
        fullName: values.fullName,
        phoneNumber: values.phoneNumber,
        emailId: values.emailId,
        address: values.address,
        city: values.city,
        pinCode: values.pinCode,
      };

      if (formik.isValid) updateDetails(data);
    },
  });

  const updateDetails = async (data: UpdateUserPersonalDetailsrequest) => {
    try {
      setSuccessMsg('');
      setErrorMsg('');
      setProgress(true);
      const userName = sessionStorage.getItem('username');
      const response = await API_V2.put(
        `/account/v2/users/${userName}/profile`,
        data,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );

      setSuccessMsg('Details saved successfully');
      setTimeout(() => fetchData(), 1000);
    } catch (err) {
      setErrorMsg(err?.response?.data?.message);
    } finally {
      setProgress(false);
    }
  };

  return (
    <>
      <div className="report-page">
        <IonRow>
          <IonCol sizeMd="1.7" sizeLg="1.7" className="web-view">
            <div className="compt-menu-section">
              <div className="sticky-col">
                <CompetitionsMenu loggedIn={true} />
              </div>
            </div>
          </IonCol>
          <IonCol sizeXs="12" sizeSm="12" sizeMd="8.3" sizeLg="8.3">
            <div className="reports-ctn">
              <div className="carw">
                <div className="arrow arrow-right">My Profile</div>
              </div>

              {/* <div className="btn-ctn web-view">
                <Button
                  className="save-btn"
                  color="primary"
                  type="submit"
                  endIcon={progress ? <IonSpinner name="lines-small" /> : null}
                  variant="contained"
                  onClick={() => {
                    if (formik.isValid) formik.handleSubmit();
                  }}
                >
                  <IonIcon src={savebtn} className="icon" />
                  Save
                </Button>
              </div> */}
              <IonCard className="my-profile-ctn">
                <IonCardContent className="my-profile-user-details-ctn">
                  <div className="personal-tab-ctn">
                    {loading ? (
                      <IonLoading
                        isOpen={loading}
                        message={'Fetching user details...'}
                      />
                    ) : (
                      <form onSubmit={formik.handleSubmit}>
                        <IonRow>
                          <IonCol>
                            <IonInput
                              value={userDetails ? userDetails.username : null}
                              disabled
                              placeholder="User Name"
                              type="text"
                            />
                          </IonCol>
                        </IonRow>
                        <IonRow>
                          <IonCol>
                            <input
                              id="user-adornment-FullName"
                              type="text"
                              name="fullName"
                              placeholder="Full Name"
                              value={formik.values.fullName}
                              className="input-design"
                              onChange={(e) =>
                                /^[a-zA-Z\s]*$/g.test(e.target.value) &&
                                formik.handleChange(e)
                              }
                              // onInput={(e) => console.log(e)}
                              readOnly
                            />
                            {formik.touched.fullName &&
                            formik.errors.fullName ? (
                              <FormHelperText
                                id="my-helper-text"
                                className="my-helper-text"
                              >
                                {formik.errors.fullName}
                              </FormHelperText>
                            ) : null}
                          </IonCol>
                        </IonRow>
                        <IonRow>
                          <IonCol>
                            <input
                              id="user-adornment-emailId"
                              type="text"
                              name="emailId"
                              placeholder="Email"
                              value={formik.values.emailId}
                              className="input-design"
                              readOnly
                              // onChange={(e) =>
                              //   /^[a-zA-Z\s]*$/g.test(e.target.value) &&
                              //   formik.handleChange(e)
                              // }
                              // onInput={(e) => formik.handleChange(e)}
                              {...formik.getFieldProps('emailId')}
                            />
                            {formik.touched.emailId && formik.errors.emailId ? (
                              <FormHelperText
                                id="my-helper-text"
                                className="my-helper-text"
                              >
                                {formik.errors.emailId}
                              </FormHelperText>
                            ) : null}
                          </IonCol>
                        </IonRow>
                        <IonRow>
                          {/* <IonCol className="label-col">
                          <IonLabel>Phone Number</IonLabel>
                        </IonCol> */}
                          <IonCol>
                            <IonInput
                              id="user-adornment-phone"
                              type="text"
                              // inputMode="tel"
                              name="phoneNumber"
                              placeholder="Phone Number"
                              value={formik.initialValues.phoneNumber}
                              onInput={(e) => formik.handleChange(e)}
                              {...formik.getFieldProps('phoneNumber')}
                              readonly
                            />
                            {formik.touched.phoneNumber &&
                            formik.errors.phoneNumber ? (
                              <FormHelperText
                                id="my-helper-text"
                                className="my-helper-text"
                              >
                                {formik.errors.phoneNumber}
                              </FormHelperText>
                            ) : null}
                          </IonCol>
                        </IonRow>
                        {/* <IonRow>
                        <IonCol>
                          <IonInput
                            name="address"
                            value={formik.values.address}
                            onInput={(e) => formik.handleChange(e)}
                            placeholder="Address"
                          ></IonInput>
                          {formik.touched.address && formik.errors.address ? (
                            <FormHelperText
                              id="my-helper-text"
                              className="my-helper-text"
                            >
                              {formik.errors.address}
                            </FormHelperText>
                          ) : null}
                        </IonCol>
                      </IonRow>
                      <IonRow>
                        <IonCol>
                          <IonInput
                            name="city"
                            value={formik.values.city}
                            onInput={(e) => formik.handleChange(e)}
                            placeholder="City"
                          ></IonInput>
                          {formik.touched.city && formik.errors.city ? (
                            <FormHelperText
                              id="my-helper-text"
                              className="my-helper-text"
                            >
                              {formik.errors.city}
                            </FormHelperText>
                          ) : null}
                        </IonCol>
                      </IonRow>
                      <IonRow>
                        <IonCol>
                          <IonInput
                            className="input-address"
                            name="pinCode"
                            type="number"
                            placeholder="pinCode"
                            value={formik.values.pinCode}
                            onInput={(e) => formik.handleChange(e)}
                          ></IonInput>
                          {formik.touched.pinCode && formik.errors.pinCode ? (
                            <FormHelperText
                              id="my-helper-text"
                              className="my-helper-text"
                            >
                              {formik.errors.pinCode}
                            </FormHelperText>
                          ) : null}
                        </IonCol>
                      </IonRow> */}
                        {/* <IonRow className="my-profile-ctn-footer">
                          <IonCol>
                            {errorMsg !== '' ? (
                              <div className="err-section">
                                <div className="err-box">
                                  <div className="msg">
                                    {errorMsg && errorMsg}
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {successMsg !== '' ? (
                              <div className="err-section">
                                <div className="success-box">
                                  <div className="msg">
                                    {successMsg && successMsg}
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            <Button
                              className="submit-btn mob-view"
                              color="primary"
                              type="submit"
                              endIcon={
                                progress ? (
                                  <IonSpinner name="lines-small" />
                                ) : null
                              }
                              variant="contained"
                            >
                              {' '}
                              <IonIcon src={savebtn} className="icon" />
                              Save Changes
                            </Button>{' '}
                          </IonCol>
                        </IonRow> */}
                      </form>
                    )}
                  </div>
                </IonCardContent>
              </IonCard>
            </div>
          </IonCol>
          <IonCol sizeMd="2" sizeLg="2" className="web-view">
            <div className="compt-menu-section">
              <RightSideNav1 />
            </div>
          </IonCol>
        </IonRow>
      </div>
    </>
  );
};

export default MyProfile;
